import { Row } from "reactstrap";
import React, { useState, useEffect } from "react";
import Faq from "react-faq-component";
import { Badge, Link } from "@shopify/polaris";
import callApi from "../../utils/apiCaller";

const FAQs = () => {
  const [listFAQs, setlistFAQs] = useState([]);
  const [data, setData] = useState({ rows: listFAQs });

  useEffect(() => {
    let params = {
      action: "getDataFAQs",
    };
    callApi("get", params).then((res) => {
      if (res.data.state === 1) {
        let firstFaqs = {
          title: "Meaning of order status on the application",
          content: (
            <div className="p-2" style={{ lineHeight: "32px" }}>
              <Badge status="success" progress="complete">
                Completed
              </Badge>{" "}
              Successfully synchronized to PayPal,
              <br />
              <Badge status="info" progress="partiallyComplete">
                Pending
              </Badge>{" "}
              Orders are waiting to be synchronized,
              <br />
              <Badge status="warning">No Tracking Number</Badge>
              Order tracking number is not available on Shopify yet,
              <br />
              <Badge status="warning">Invalid Tracking Number</Badge> The
              tracking number is in wrong or incorrect format,
              <br />
              <Badge status="warning">No Transaction id</Badge> Shopify or the
              payment app does not return a PayPal transaction ID (checkoutX is
              not compatible with the app),
              <br />
              <Badge status="warning">Over quota</Badge> Excess limit under
              subscription Plan,
              <br />
              <Badge status="critical">No Account Connected</Badge> No PayPal
              accounts connected,
              <br />
              <Badge progress="complete" status="critical">
                Missing PayPal account
              </Badge>{" "}
              The account corresponding to the payment account for the order has
              not been connected,
            </div>
          ),
        };
        let listFAQs = res.data.listFAQs;
        listFAQs.unshift(firstFaqs);
        for (let $i = 0; $i < listFAQs.length; $i++) {
          listFAQs[$i].title = $i + 1 + ". " + listFAQs[$i].title;
        }
        setlistFAQs({ rows: listFAQs });
      }
    });
  }, []);

  const styles = {
    // bgColor: 'white',
    rowTitleColor: "#1f5199",
    rowContentColor: "grey",
    // arrowColor: "red",
  };

  const config = {
    animate: true,
    // arrowIcon: "V",
    // tabFocus: true
  };

  const [rating, setRating] = useState(5);
  const listVideo = [
    {
      title: "TUTORIAL: Connect your PayPal account to the SyncTrack app",
      url: "939S7HqgJi4",
    },
    {
      title:
        "[SyncTrack ‑ Add tracking auto] - Instructions for integrating multiple stores",
      url: "pokFbQ3YvHc",
    },
  ];
  return <Faq data={listFAQs} styles={styles} config={config} />;
};

export default FAQs;
